export default __webpack_public_path__ + "static/media/me_and_cat.7e395d02.jpg";